













































































































































































































































































































































































































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
/* component */
import Loading from '@/app/components/Common/Loading.vue'
import FieldImg from '@/app/components/Field/FieldImg.vue'
/* module */
import { fieldDetailsData } from '@/app/model/store/domain/types'
import Session from '@/app/module/session'
import { routerPath } from '@/app/model/store/domain/const'
import DetailsContent from '../FieldDetails/DetailsContent.vue'
import Local from '@/app/module/local'
import DateClass from '@/app/module/date'
import CommonClass from '@/app/module/common'

@Component({
  components: {
    Loading,
    FieldImg
  }
})
export default class FieldListItem extends Vue {
  /* クラス */
  private isActiveClass: boolean = false
  private isModalActiveClass: boolean = false
  /* 表示切り替え */
  private showToDetails: boolean = true
  private showFieldItem: boolean = false
  private showNodata: boolean = false
  private showLackData: boolean = false
  private showLoading: boolean = false
  /* データ */
  private detailsData: any = this.defultDetail()
  private fieldId: string = ''
  private memori: number[] = []
  private oneMemoriWidth: number = 0
  private oneWidthTemperature:number = 0
  private maxIntegrationTemperature: number = 2300
  private linkTo: string = ''
  private gradeList: Array<{[key:string]: string|number}> = []

  private get fieldSortFlag (): boolean {
    return this.$store.state.fieldState.fieldSortFlag
  }
  @Watch('fieldSortFlag')
  getFieldSortFlag (flag: boolean) {
    // リストの並び替えが終わってたらitemを再生成
    if (!flag) {
      this.linkTo = '/field/' + this.item.field_id
      // 選択中の圃場にactiveクラス追加
      let id = this.$store.state.fieldChoiceState.id
      if (this.item.field_id === parseInt(id)) {
        this.isActiveClass = true
      } else {
        this.isActiveClass = false
      }
      this.getFieldDetailsData()
    }
  }

  @Prop() private item!:any
  @Prop() private accordionId!: number
  @Prop() private flag!: boolean // アコーディオン開閉フラグ
  @Prop() private displayFlag!: boolean // 圃場一覧画面かモーダルかのフラグ
  @Prop() private accordionChangeFlag!: boolean
  /* computed */
  private get fieldChoiceState (): number {
    return this.$store.state.fieldChoiceState.id
  }
  private get modalFieldChoiceState (): number {
    return this.$store.state.fieldChoiceState.modalId
  }
  private get detailsDataFlag (): boolean {
    return this.$store.state.setFlagState.fieldDetailsDataFlag
  }
  private get modalMetailsDataFlag (): boolean {
    return this.$store.state.setFlagState.fieldModalDetailsFlag
  }
  private get accordionFlag (): boolean {
    return this.accordionChangeFlag
  }
  private get openGraphSettingFlag (): boolean {
    return this.$store.state.setFlagState.openSettingModalFlag
  }
  @Watch('fieldChoiceState')
  onIdChange (newValue: string) {
    this.fieldId = newValue
    if (this.displayFlag) {
      Session.setChoiceFieldId(String(newValue))
      if (this.item.field_id === parseInt(this.fieldId)) {
        this.isActiveClass = true
      } else {
        this.isActiveClass = false
      }
    } else {
      if (this.item.field_id === parseInt(this.fieldId)) {
        this.isModalActiveClass = true
      } else {
        this.isModalActiveClass = false
      }
    }
  }
  @Watch('modalFieldChoiceState')
  ooModalIdChange (newValue: string) {
    if (newValue === this.item.field_id) {
      if (this.detailsData.planting.planting_id !== 0) {
        this.isModalActiveClass = true
      }
    } else {
      this.isModalActiveClass = false
    }
  }
  @Watch('detailsDataFlag')
  getDetailsDataFlag (flag: boolean) {
    if (flag) {
      this.linkTo = '/field/' + this.item.field_id
      this.getFieldDetailsData()
    }
  }
  @Watch('modalMetailsDataFlag')
  getModalDetailsDataFlag (flag: boolean) {
    if (flag) {
      this.getModalDetailsData()
      this.showLoading = false
    }
  }
  @Watch('accordionFlag')
  getAccordionFlag () {
    this.progressMemori()
  }
  @Watch('openGraphSettingFlag')
  getOpenSettingModalFlag (flag: boolean) {
    if (flag) {
      this.progressMemori()
    }
  }

  created () {
    // 等級の配列を作成
    const constantValue = JSON.parse(Local.getConstantValue()!)
    this.gradeList = constantValue.grades

    // 画面かモーダルかの判定
    if (!this.displayFlag) {
      this.showToDetails = false
      this.showLoading = true
      this.getModalDetailsData()
      return
    }

    if (this.$store.state.setFlagState.fieldDetailsDataFlag) {
      this.linkTo = '/field/' + this.item.field_id
      this.getFieldDetailsData()
    } else {
      // 詳細データがない場合
      this.linkTo = '/field/' + this.item.field_id
      this.$emit('show-loading')
    }
  }

  mounted () {
    // 圃場詳細 グラフ表示項目保持で比較圃場選択されていた場合選択表示
    let settingData = JSON.parse(Local.getGraphSettingData(this.$route.params.field_id)!)
    if (this.$route.name === '圃場詳細' && settingData !== null && settingData.tab === '3') {
      if (settingData.fieldId === this.item.field_id) {
        this.isModalActiveClass = true
      }
    }

    window.addEventListener('resize', this.progressMemori)
  }

  private getGradeName (id: number) {
    for (let i in this.gradeList) {
      if (id === this.gradeList[i].grade_id) {
        return this.gradeList[i].grade_name
      }
    }
    return '-'
  }

  private displayPlantingType (type: number) {
    return CommonClass.displayPlantingType(type)
  }

  private displayValue (value: string|number) {
    return value !== null && value !== undefined ? value : '-'
  }

  /* 詳細データ取得 */
  private async getFieldDetailsData () {
    let detailsContent: any = await Session.getFieldDetailsData(String(this.accordionId))!
    detailsContent = JSON.parse(detailsContent)

    this.showFieldItem = true
    // timestamp削除
    if (detailsContent !== null) {
      delete detailsContent[0]
    }
    if (this.item.field_id === parseInt(this.$store.state.fieldChoiceState.id)) {
      this.isActiveClass = true
    } else {
      this.isActiveClass = false
    }

    if (detailsContent !== null && this.item.field_id !== 0) {
      const id = this.item.field_id
      let detailData = detailsContent.filter(function (data: any) {
        return (data.field_id === id)
      })

      let result = {}
      if (detailData[0] !== undefined) {
        // 欠損データがある場合
        if (detailData[0].planting.max_intergration_temperature === 0) {
          this.showLackData = true
          this.showNodata = false
        } else {
          this.showLackData = false
          this.showNodata = false
        }

        this.maxIntegrationTemperature = detailData[0].planting.max_intergration_temperature
        this.detailsData = detailData[0]
        this.progressMemori()
      }

      /* 圃場一覧取得後、圃場詳細取得前に圃場が削除された時用にundifined */
      if (this.detailsData.planting.planting_id === undefined || this.detailsData.planting.planting_id === 0) {
        this.showLackData = false
        this.showNodata = true
        this.detailsData = this.defultDetail()
      }
    } else {
      this.showNodata = true
      this.detailsData = this.defultDetail()
      this.showFieldItem = true
    }
    this.$emit('show-loading')

    /* フラグリセット */
    this.$store.commit('fieldState/setFieldSortFlag', true)
    this.$store.commit('setFlagState/setFieldDetailsDataFlag', false)
  }

  /* モーダルの詳細データを取得 */
  private async getModalDetailsData () {
    let detailsContent: any = await Session.getModalFieldDetailsData(String(this.accordionId))!
    detailsContent = JSON.parse(detailsContent)

    this.showFieldItem = true
    // timestamp削除
    if (detailsContent !== null) {
      delete detailsContent[0]
    }
    if (this.item.field_id === parseInt(this.$store.state.fieldChoiceState.modalId)) {
      this.isModalActiveClass = true
    } else {
      this.isModalActiveClass = false
    }

    if (this.item.field_id !== 0) {
      for (var i in detailsContent) {
        let result = {}
        if (this.item.field_id === detailsContent[i].field_id) {
          // 欠損データがある場合
          if (detailsContent[i].planting.max_intergration_temperature === 0) {
            this.showLackData = true
            this.showNodata = false
          } else {
            this.showLackData = false
          }

          result = detailsContent[i]
          this.maxIntegrationTemperature = detailsContent[i].planting.max_intergration_temperature
          this.detailsData = result
          this.showNodata = false
          this.progressMemori()
        }

        if (detailsContent[i].planting.planting_id === undefined || this.detailsData.planting.planting_id === 0) {
          this.showNodata = true
          // 初期値に戻す
          this.detailsData = this.defultDetail()
        }
      }
      this.$emit('show-loading')
    } else {
      this.showNodata = true
      // 初期値に戻す
      this.detailsData = this.defultDetail()
      this.showFieldItem = true
      this.$emit('show-loading')
    }

    if (detailsContent !== null) {
      this.showLoading = false
    }

    /* フラグリセット */
    this.$store.commit('fieldState/setFieldSortFlag', true)
    this.$store.commit('setFlagState/setFieldModalDetailsFlag', false)
  }

  private defultDetail () {
    return {
      field_id: 0,
      field_name: '-',
      point: {
        lng: '',
        lat: ''
      },
      planting: {
        planting_id: 0,
        planting_type: 0,
        planting_cultivation_method_name: '-',
        grade_gole: 0,
        variety: {
          variety_id: 0,
          variety_name: '-',
          variety_cultivation_method_name: '-'
        },
        user: {
          user_name: '-',
          user_id: 0
        },
        images: {},
        growth_stage_name: '-',
        harvest_limit_date: 0,
        harvest_date: '',
        max_intergration_temperature: 0,
        intergration_temperature: 0,
        temperature: null,
        rainfall: null,
        risk: {
          sickness: false,
          weeds: false,
          pest: false,
          high_temperature: false,
          fallen_fruit: false
        }
      }
    }
  }

  /* プログレスバーメモリ */
  private progressMemori () {
    const targetWidth:any = this.$refs.getBarWidth
    if (targetWidth !== undefined) {
      this.oneWidthTemperature = this.maxIntegrationTemperature / targetWidth.clientWidth
      this.oneMemoriWidth = 500 / this.oneWidthTemperature
      this.memori = []

      for (var i = 500; i < this.maxIntegrationTemperature; i += 500) {
        this.memori.push(i)
      }
    }
  }

  /* リストをクリックした際にstate管理する */
  private setChoiceField (id: number) {
    if (!this.displayFlag) {
      if (id !== this.$store.state.fieldChoiceState.modalId) {
        this.$store.commit('fieldChoiceState/setChoosingModalFieldId', id)
        this.$store.commit('fieldChoiceState/setIsScroll', false)
        this.$store.commit('fieldChoiceState/setModalPlantingId', this.detailsData.planting.planting_id)
      } else {
        this.$store.commit('fieldChoiceState/setClickModalFlag', true)
      }
    } else {
      this.isActiveClass = true
      if (id !== this.$store.state.fieldChoiceState.id) {
        Session.setChoiceFieldId(String(id))
        this.$store.commit('fieldChoiceState/setChoosingFieldId', id)
        this.$store.commit('fieldChoiceState/setIsScroll', false)
        this.$store.commit('fieldChoiceState/setChoosingFieldData',
          {
            fieldId: this.item.field_id,
            fieldName: this.item.field_name
          }
        )
      } else {
        this.$store.commit('fieldChoiceState/setClickFlag', true)
      }
    }
  }

  private displayHarvestLimit (limitDay: number) {
    return DateClass.displayHarvestLimit(limitDay)
  }

  private displayHarvestLimitDay (limitDay: number) {
    return DateClass.displayHarvestLimitDay(limitDay)
  }

  private displayHarvestDay (limitDay: number, date: string) {
    return DateClass.displayHarvestDay(limitDay, date)
  }

  /* 日平均気温アイコン */
  judgmentTemperatureIcon (val: number|null) {
    if (val !== null) {
      return require('@/assets/icon/ico_watertemperature1.png')
    } else {
      return require('@/assets/icon/ico_watertemperature0.png')
    }
  }

  /* 日積算降水量アイコン */
  judgmentRainfallIcon (val: number|null) {
    if (val !== null) {
      return require('@/assets/icon/ico_waterlevel1.png')
    } else {
      return require('@/assets/icon/ico_waterlevel0.png')
    }
  }
}
